/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {batchGetTimecardBreakDefinition} from '../api'

export const useMutationBatchGetTimecardBreakDefinition = createReactQueryMutationHook('batchGetTimecardBreakDefinition', batchGetTimecardBreakDefinition)
